<template>
  <div class="section">
    <div class="section__slider">
      <h1 class="sliderTitle mx-sm-14 mx-4">
        <!-- <span class="d-block">{{ commonData.date }}</span> -->
        {{ commonData.sliderTitle }}
        <!-- <span class="d-block">{{ commonData.sliderSubtitle }}</span> -->
      </h1>
      <VueSlickCarousel v-if="this.sliderItems.length > 0" v-bind="settings">
        <div
          v-for="slide in sliderItems"
          class="section__slider-item"
          :key="slide"
        >
          <img
            class="sliderImage"
            :src="require(`@/assets/img/slides/${slide}`)"
            alt=""
          />
        </div>
      </VueSlickCarousel>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  name: "MainSection",
  components: {
    VueSlickCarousel
  },
  computed: {
    commonData() {
      return this.$t("common");
    }
  },
  data: () => ({
    sliderItems: [
      "slide_2.webp",
      "slide_2.jpg",
      "slide_4.webp",
      "slide_5.webp",
      "slide_6.webp",
      "slide_7.webp",
      "slide_8.webp",
      "slide_9.webp",
      "slide_1.jpg"
    ],
    settings: {
      arrows: true,
      dots: true,
      infinite: true,
      autoplay: true
    }
  })
};
</script>

<style lang="sass" scoped>

.sliderImage
  width: 100%
  height: 100%
  object-fit: cover

.section
    width: 100%
    min-height: 100vh
    position: relative
    color: #ffffff
    &__slider
        position: relative
        width: 100%
        height: 100vh
        &-item
            width: 100%
            height: 100vh
            background-size: cover
            background-position: center
            position: relative
            outline: none
            &:before
              content: ""
              position: absolute
              left: 0
              top: 0
              width: 100%
              height: 100%
              background-color: #262626
              opacity: .5


.sliderTitle
  z-index: 2
  position: absolute
  top: 50%
  transform: translateY(-50%)
  font-size: 2.8rem
  line-height: 4rem
  letter-spacing: .01em
  width: 38rem

@media (max-width: 600px)
  .section
    min-height: 100vh !important
    &__slider
      position: relative
      height: 100vh !important
      &-item
        height: 100vh !important


  .sliderTitle
    width: 90vw !important
    font-size: 2.8rem !important
</style>

<style lang="sass">
@media (max-width: 600px)
  .section
    &__slider
      .slick-dots
        display: none !important

.section
  &__slider
    .slick-dots
      top: 50%
      right: 4rem
</style>
